import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../base/base.component';

@Component({
  selector: 'app-report-bottom-toolbar',
  templateUrl: './report-bottom-toolbar.component.html',
  styleUrl: './report-bottom-toolbar.component.scss',
  standalone: false,
})
export class ReportBottomToolbarComponent extends BaseComponent {}
